import moment from "moment";
import format from "string-template";
import { DATE_FORMAT, REGEX_EXPS } from "utils/constants";
import { isMajor } from "utils/helpers/date";
import * as yup from "yup";

const validator = (
  messages,
  {
    addressZipCodeCity,
    setCities,
    deltaRia,
    deltaStart,
    deltaEnd,
    deltaEndRia,
  },
) => {
  const requiredString = yup
    .string()
    .typeError(messages.REQUIRED)
    .required(messages.REQUIRED);
  const requiredName = yup
    .string()
    .typeError(messages.REQUIRED)
    .matches(REGEX_EXPS.name, messages.INVALID_NAME)
    .required(messages.REQUIRED);
  const childValidationSchema = yup.object().shape({
    identity: yup.object().shape({
      user: yup.object().shape({
        birthDate: yup
          .date()
          .typeError(messages.REQUIRED)
          .max(moment(), messages.MIN_TODAY)
          .required(messages.REQUIRED),
      }),
      // socialRegime: requiredString,
    }),
  });
  return yup.object().shape({
    contract: yup.mixed().when("locked", {
      is: (locked) => locked,
      then: yup.object().shape({
        issuanceDate: yup
          .date()
          .typeError(messages.REQUIRED)
          .required(messages.REQUIRED),
      }),
      otherwise: yup.mixed().when("ria", {
        is: (ria) => ria,
        then: yup.object().shape({
          issuanceDate: yup
            .date()
            .typeError(messages.REQUIRED)
            .min(
              moment().startOf("day").add(deltaRia, "days"),
              format(messages.MIN_DATE, {
                date: moment()
                  .startOf("day")
                  .add(deltaRia, "days")
                  .format(DATE_FORMAT),
              }),
            )
            .required(messages.REQUIRED),
        }),
        otherwise: yup.object().shape({
          issuanceDate: yup
            .date()
            .typeError(messages.REQUIRED)
            .min(
              moment().startOf("day").add(deltaStart, "days"),
              format(messages.MIN_DATE, {
                date: moment()
                  .startOf("day")
                  .add(deltaStart, "days")
                  .format(DATE_FORMAT),
              }),
            )
            .required(messages.REQUIRED),
        }),
      }),
    }),
    contact: yup.object().shape({
      user: yup.object().shape({
        gender: requiredString,
        lastname: requiredName,
        firstname: requiredName,
        birthDate: yup
          .date()
          .typeError(messages.REQUIRED)
          .max(isMajor, messages.AGE_18)
          .required(messages.REQUIRED),
      }),
      fields: yup.object().shape({
        profile: requiredString,
      }),
    }),
    zipCode: yup.object().shape({
      value: yup
        .string()
        .typeError(messages.REQUIRED)
        .test("isValid", messages.INVALID_VALUE, async function (value) {
          const isValidRegex = new RegExp(REGEX_EXPS.zipCode).test(value);
          if (!isValidRegex) return false;
          const {
            data: {
              franceAddressZipCodeCity: { response },
            },
          } = await addressZipCodeCity({
            variables: {
              where: { zipCode: value },
            },
          });
          setCities(response);
          return response.length;
        }),
    }),
    city: yup.object().shape({
      value: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED),
    }),
    phoneNumber: yup.object().shape({
      value: yup
        .string()
        .nullable()
        .test("isValid", messages.INVALID_VALUE, async function (value) {
          return !value
            ? true
            : new RegExp(REGEX_EXPS.internationalMobilePhone).test(
                value?.replace(/\s+/g, ""),
              );
        }),
    }),
    children: yup.array().of(childValidationSchema),
    hasSpouse: yup.boolean().nullable(),
    spouse: yup.object().when("hasSpouse", {
      is: (hasSpouse) => hasSpouse,
      then: yup.object().shape({
        identity: yup.object().shape({
          user: yup.object().shape({
            birthDate: yup
              .date()
              .typeError(messages.REQUIRED)
              .max(isMajor, messages.RADIANCE.SPOUSE_AGE)
              .min(
                moment().subtract(100, "year").startOf("year"),
                messages.RADIANCE.SPOUSE_AGE,
              )
              .required(messages.REQUIRED),
          }),
          // socialRegime: requiredString,
        }),
      }),
    }),
  });
};

export default validator;
